import "./index.css"
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import Photo from "./pages/Photo";
import Streaming from "./pages/Streaming";
import Video from "./pages/Video";

const router = createBrowserRouter([
    { path: '/video', element: <Video/>},
    { path: '/streaming', element: <Streaming/>},
    { path: '/photo', element: <Photo/>},
    { path: '/', element: <Photo/>}
])

function App() {
    return <RouterProvider router={router} />;
}


export default App;
